export const TimeInput = {
  mounted() {
    this.el.addEventListener("keypress", (e) => {
      if (!/[\d:]/.test(e.key)) {
        e.preventDefault();
      }
    });
  },
};
